/*
 * TheNerv — mobile menu drawer
 *
 * The panel is shown/hidden by CSS in sections/header.liquid, keyed on the
 * `open` attribute of the <details>. This script's only job is to toggle that
 * attribute correctly and keep aria state and body scroll in sync.
 */
if (!customElements.get('header-drawer')) {
  class HeaderDrawer extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.details && this.details.querySelector('summary');
      if (!this.details || !this.summary) return;

      this.bindEvents();
    }

    bindEvents() {
      // Hamburger — toggles, so tapping the X closes it again.
      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        this.details.hasAttribute('open') ? this.close() : this.open();
      });

      // "Close menu" button inside the drawer header
      this.querySelectorAll('.menu-drawer__close-menu-btn').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.close();
        });
      });

      // Parent links that open a sub-menu
      this.querySelectorAll('.menu-drawer__submenu').forEach((submenu) => {
        const details = submenu.closest('details');
        const summary = details && details.querySelector('summary');
        if (!summary || summary === this.summary) return;

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          const isOpen = details.hasAttribute('open');
          details.toggleAttribute('open', !isOpen);
          details.classList.toggle('menu-opening', !isOpen);
          summary.setAttribute('aria-expanded', String(!isOpen));
        });
      });

      // "Back" buttons inside sub-menus
      this.querySelectorAll('.menu-drawer__close-button').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const details = button.closest('details');
          if (!details) return;
          details.classList.remove('menu-opening');
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        });
      });

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && this.details.hasAttribute('open')) this.close();
      });
    }

    open() {
      this.details.setAttribute('open', '');
      this.details.classList.add('menu-opening');
      this.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.details.classList.remove('menu-opening');
      this.details.removeAttribute('open');
      this.removeAttribute('open');
      this.summary.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');

      // Collapse sub-menus so the drawer reopens at the top level
      this.querySelectorAll('details[open]').forEach((details) => {
        details.classList.remove('menu-opening');
        details.removeAttribute('open');
      });
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
}